"use client";

import { fetchData } from "@/api/api";
import Link from "next/link";
import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import styles from "./HeaderNavigation.module.css";

const HeaderNavigation = () => {
  const [menusData,        setMenusData]        = useState<any[]>([]);
  const [loadingData,      setLoadingData]      = useState(true);
  const [desktopDropdown,  setDesktopDropdown]  = useState<number | null>(null);

  const getCategoriesAndBrands = async () => {
    try {
      setLoadingData(true);

      const [catRes, brandRes] = await Promise.all([
        fetchData({ url: `/customer/categories`, cache: "force-cache" }),
        fetchData({ url: `/customer/brands`,     cache: "force-cache" }),
      ]);

      const categories = catRes?.data  || [];
      const brands     = brandRes?.data || [];

      const categoryMenu = {
        link: "/shop", title: "Categories", hasDropdown: true,
        dropdownItems: categories.map((cat: any) => ({
          link: `/shop?category=${cat.id}&price=1000000`, title: cat.name,
        })),
      };
      const brandMenu = {
        link: "/shop", title: "Brands", hasDropdown: true,
        dropdownItems: brands.map((brand: any) => ({
          link: `/shop?brand=${brand.id}&price=1000000`, title: brand.name,
        })),
      };

      setMenusData([
        { link: "/",        title: "Home",      hasDropdown: false },
        categoryMenu,
        brandMenu,
        { link: "/about",   title: "About Us",  hasDropdown: false },
        { link: "/contact", title: "Contact",   hasDropdown: false },
      ]);
    } catch (error) {
      console.error("Navigation fetch error:", error);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => { getCategoriesAndBrands(); }, []);

  return (
    <div className={styles.navWrapper}>
      {loadingData ? null : (
        menusData.map((item, idx) => (
          <div
            key={idx}
            className={styles.navItemWrap}
            onMouseEnter={() => setDesktopDropdown(idx)}
            onMouseLeave={() => setDesktopDropdown(null)}
          >
            <Link
              href={item.link}
              className={`${styles.navLink} ${desktopDropdown === idx ? styles.navLinkActive : ""}`}
            >
              {item.title}
              {item.hasDropdown && (
                <ChevronDown
                  size={16}
                  className={`${styles.chevron} ${desktopDropdown === idx ? styles.chevronOpen : ""}`}
                />
              )}
            </Link>

            {item.hasDropdown && desktopDropdown === idx && (
              <div className={styles.dropdown}>
                {item.dropdownItems.map((menu: any, i: number) => (
                  <Link key={i} href={menu.link} className={styles.dropdownLink}>
                    {menu.title}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default HeaderNavigation;